<template>
  <div class="utd-search-bar-wrap">
    <el-form ref="form" class="utd-search-bar el-form flex items-center content-around">
      <div class="flex px-2 w-14">
        <img class="m-auto w-full rounded-lg" src="../../assets/images/image1.png" />
      </div>
      <el-form-item class="mb-0 w-100 px-2">
        <el-select
          ref="upToDateSearch"
          :value="value"
          clearable
          filterable
          remote
          reserve-keyword
          :placeholder="$t('uptodate.lbl_enter_keyword')"
          :remote-method="handleRemoteMethod"
          :loading="loading"
          class="typing"
          v-shortkey="['ctrl', '/']"
          @shortkey.native="handleFocusByShortkey"
          @change="handleChange"
          @input="handleInput"
        >
          <el-option v-for="item in options" :key="item" :label="item" :value="item" />
          <span slot="prefix" class="py-1 px-1 bg-gray-200 text-gray-500 shadow-sm rounded-sm">Ctrl + /</span>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'UtdSearchBar',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    focusInput () {
      this.$refs.upToDateSearch && this.$refs.upToDateSearch.focus()
    },
    handleFocusByShortkey () {
      this.$emit('focus-shortkey')
    },
    handleChange (value) {
      this.$emit('change', value)
    },
    handleInput (value) {
      this.$emit('input', value)
    },
    handleRemoteMethod (value) {
      this.$emit('remote-method', value)
    }
  }
}
</script>

<style scoped>
.utd-search-bar-wrap {
  /* width: 100%; */
  min-width: 0;
}

.utd-search-bar {
  width: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 4px 0px;
}

.typing {
  width: 100%;
}

.typing /deep/ .el-input__prefix {
  left: auto;
  right: 5px;
}

.typing /deep/ .el-input__suffix {
  right: 60px;
}

.typing /deep/ .el-input--prefix .el-input__inner {
  padding-left: 8px;
}

.typing /deep/ .el-input--suffix .el-input__inner {
  padding-right: 60px;
}

.typing /deep/ .el-input__inner {
  height: 32px;
  line-height: 32px;
  border: 1px solid transparent !important;
  transition: all 0.3s ease;
}

.typing /deep/ .el-input__icon {
  line-height: 32px;
}

.typing /deep/ .el-input__inner:focus {
  border: 1px solid #20429b !important;
  box-shadow: 0 0 5px 0 #20429b !important;
}
</style>
